import { CARD_URL, PAYPAL_URL, KLARNA_URL, AFTERPAY_URL, APPLE_PAY_URL, GOOGLE_PAY_URL } from '../../checkoutConstants';

export const PAYMENT_METHOD = {
  CARD: 'CARD',
  PAYPAL: 'PAYPAL',
  ZEROVALUE: 'ZEROVALUE',
  KLARNA: 'KLARNA',
  PAYPAL_EXPRESS: 'PAYPAL_EXPRESS',
  GOOGLE_PAY: 'GOOGLE_PAY',
  GOOGLE_PAY_CLASSIC: 'GOOGLE_PAY_CLASSIC',
  APPLE_PAY: 'APPLE_PAY',
  APPLE_PAY_CLASSIC: 'APPLE_PAY_CLASSIC',
  AFTERPAY: 'AFTERPAY',
};

export const CARD_ICON_MAPPER = {
  visa: 'visa',
  paypal: 'paypal',
  klarna: 'klarna',
  mc: 'mastercard',
  amex: 'americanexpress',
  discover: 'discover',
  afterpay: 'afterpay',
  applepay: 'apple_pay',
  googlepay: 'google_pay',
};

export const PAYMENT_TYPES_MAP = {
  [CARD_URL]: PAYMENT_METHOD.CARD,
  [PAYPAL_URL]: PAYMENT_METHOD.PAYPAL,
  [KLARNA_URL]: PAYMENT_METHOD.KLARNA,
  [AFTERPAY_URL]: PAYMENT_METHOD.AFTERPAY,
  [APPLE_PAY_URL]: PAYMENT_METHOD.APPLE_PAY_CLASSIC,
  [GOOGLE_PAY_URL]: PAYMENT_METHOD.GOOGLE_PAY_CLASSIC,
};

export const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
